import {
  MFG_DASHBOARD_REQUEST, MFG_DASHBOARD_SUCCESS, MFG_DASHBOARD_FAILURE,
  MFG_QUICK_SUMMARY_REQUEST, MFG_QUICK_SUMMARY_SUCCESS, MFG_QUICK_SUMMARY_FAILURE,
  MFG_SET_SELECTED_BATCH,
  MFG_CMO_LIST_REQUEST, MFG_CMO_LIST_SUCCESS, MFG_CMO_LIST_FAILURE,
  MFG_PLANTS_REQUEST, MFG_PLANTS_SUCCESS, MFG_PLANTS_FAILURE,
  MFG_BRANDS_REQUEST, MFG_BRANDS_SUCCESS, MFG_BRANDS_FAILURE,
  MFG_PRODUCT_TYPES_REQUEST, MFG_PRODUCT_TYPES_SUCCESS, MFG_PRODUCT_TYPES_FAILURE,
  MFG_SAVED_FILTERS,
} from '../../actions/types';

const initialState = {
  dashboard: {
    loading: false,
    error: null,
    data: [],
    totalCount: 0,
    page: 1,
    pageSize: 5
  },
  quickSummary: {
    loading: false,
    error: null,
    plannedBatches: 0,
    underManufacturing: 0,
    underTesting: 0,
    pendingCMORelease: 0,
    pendingAmgenRelease: 0,
    readyForShipment: 0,
    shipped: 0,
    delayedHoldCancelled: 0
  },
  selectedBatch: null,
  cmoList: { loading: false, data: [], error: null },
  plantList: { loading: false, data: [], error: null },
  brandList: { loading: false, data: [], error: null },
  productTypeList: { loading: false, data: [], error: null },
  savedFilters: { status: false, save_filter_options: {} },
};

const mfgCollabReducer = (state = initialState, action) => {
  switch (action.type) {
    case MFG_DASHBOARD_REQUEST:
      return { ...state, dashboard: { ...state.dashboard, loading: true, error: null } };
    case MFG_DASHBOARD_SUCCESS:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          loading: false,
          data: action.payload.poList || [],
          totalCount: action.payload.totalCount || 0
        }
      };
    case MFG_DASHBOARD_FAILURE:
      return { ...state, dashboard: { ...state.dashboard, loading: false, error: action.payload } };
    case MFG_QUICK_SUMMARY_REQUEST:
      return { ...state, quickSummary: { ...state.quickSummary, loading: true, error: null } };
    case MFG_QUICK_SUMMARY_SUCCESS:
      return {
        ...state,
        quickSummary: {
          ...state.quickSummary,
          loading: false,
          ...action.payload
        }
      };
    case MFG_QUICK_SUMMARY_FAILURE:
      return { ...state, quickSummary: { ...state.quickSummary, loading: false, error: action.payload } };
    case MFG_SET_SELECTED_BATCH:
      return { ...state, selectedBatch: action.payload };
    // CMO list
    case MFG_CMO_LIST_REQUEST:
      return { ...state, cmoList: { ...state.cmoList, loading: true, error: null } };
    case MFG_CMO_LIST_SUCCESS:
      return { ...state, cmoList: { loading: false, data: action.payload, error: null } };
    case MFG_CMO_LIST_FAILURE:
      return { ...state, cmoList: { ...state.cmoList, loading: false, error: action.payload } };
    // Plant list
    case MFG_PLANTS_REQUEST:
      return { ...state, plantList: { ...state.plantList, loading: true, error: null } };
    case MFG_PLANTS_SUCCESS:
      return { ...state, plantList: { loading: false, data: action.payload, error: null } };
    case MFG_PLANTS_FAILURE:
      return { ...state, plantList: { ...state.plantList, loading: false, error: action.payload } };
    // Brand list
    case MFG_BRANDS_REQUEST:
      return { ...state, brandList: { ...state.brandList, loading: true, error: null } };
    case MFG_BRANDS_SUCCESS:
      return { ...state, brandList: { loading: false, data: action.payload, error: null } };
    case MFG_BRANDS_FAILURE:
      return { ...state, brandList: { ...state.brandList, loading: false, error: action.payload } };
    // Product type list
    case MFG_PRODUCT_TYPES_REQUEST:
      return { ...state, productTypeList: { ...state.productTypeList, loading: true, error: null } };
    case MFG_PRODUCT_TYPES_SUCCESS:
      return { ...state, productTypeList: { loading: false, data: action.payload, error: null } };
    case MFG_PRODUCT_TYPES_FAILURE:
      return { ...state, productTypeList: { ...state.productTypeList, loading: false, error: action.payload } };
    // Saved filters
    case MFG_SAVED_FILTERS:
      return { ...state, savedFilters: action.payload };
    default:
      return state;
  }
};

export default mfgCollabReducer;
